import { Injectable } from '@angular/core';
import { GungFlowService, Product, ProductInputQuantityConfigService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class CultProductInputQuantityConfigService extends ProductInputQuantityConfigService {
  isReturnFlow: boolean;

  constructor(protected gungFlowService: GungFlowService) {
    super();
    this.gungFlowService.getSelectedFlow().subscribe(flow => {
      if (flow.isReturnOrder) {
        this.isReturnFlow = true;
      } else {
        this.isReturnFlow = false;
      }
    });
  }

  getMinimumOrderQuantity(productId: string, product?: Product): number {
    return this.getStepAmount(productId, product);
  }

  getStepAmount(productId: string, product?: Product): number {
    let res = !this.isReturnFlow ? Math.trunc(product.extra.ar.artfsgforp) : 1;
    return res;
  }

  getRecomendedInitOrderQuantity(productId: string, product?: Product): number {
    return this.getStepAmount(productId, product);
  }
}
